import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth-slice";
import categoriesReducer from "./categories-slice";
import colorsReducer from "./colors-slice";
import configReducer from "./config-slice";
import discountsReducer from "./discounts-slice";
import homeReducer from "./home-slice";
import loginReducer from "./login-slice";
import ordersReducer from "./orders-slice";
import productsReducer from "./products-slice";

const rootReducer = combineReducers({
  auth: authReducer,
  categories: categoriesReducer,
  colors: colorsReducer,
  config: configReducer,
  discounts: discountsReducer,
  home: homeReducer,
  login: loginReducer,
  orders: ordersReducer,
  products: productsReducer,
});

export default rootReducer;
